export default "__VITE_ASSET__DQ7ph5xp__"